/* Jobs listing (v2)
 * ---------------------------------------------------------------------------
 * Markup comes from archive-jobs.php. Search & Filter Pro renders the fields
 * and swaps the results over AJAX, keeping its filters in the URL
 * (?_profession=…&_state=…). On top of that:
 *
 * - Mobile: the profession / state / specialty filters sit behind one button.
 * - Search button: runs the keyword search (the filters already apply as they
 *   change) and brings the results into view.
 * - Job alerts modal: opened by any [data-job-alerts-open], with the current
 *   filters in its intro and in the HubSpot form's matching fields.
 * - The CV form shows when a search has no results.
 *
 * Standalone (no jQuery).
 */
(function () {
	'use strict';

	var main = document.querySelector('.ashs-jobs-v2');
	if (!main) { return; }

	function each(list, fn) {
		Array.prototype.forEach.call(list, fn);
	}

	function jobs() {
		return main.querySelectorAll('.ashs-jobs-loop .ashs-job-card');
	}

	/* -- results changed ------------------------------------------------------ */

	// S&F re-renders the results container on every search. Watch it and react
	// once the DOM settles.
	function onResults(fn) {
		var timer = null;
		new MutationObserver(function () {
			clearTimeout(timer);
			timer = setTimeout(fn, 150);
		}).observe(main, { childList: true, subtree: true });
	}

	/* -- empty state ---------------------------------------------------------- */

	function toggleEmptyState() {
		var empty = main.querySelector('.ashs-jobs-loop__empty');
		if (empty) {
			var hasJobs = jobs().length > 0;
			empty.classList.toggle('d-none', hasJobs);
			// Its CV form (and reCAPTCHA) is built the first time it's shown.
			if (!hasJobs && window.ashsHsForms && window.ashsHsForms['ashs-noresults-form']) {
				window.ashsHsForms['ashs-noresults-form']();
			}
		}
	}

	/* -- mobile filters ------------------------------------------------------- */

	function initFiltersToggle() {
		var toggle = main.querySelector('.ashs-jobs-search__toggle');
		var panel = main.querySelector('#ashs-job-filters');
		if (!toggle || !panel) { return; }

		toggle.addEventListener('click', function () {
			var open = toggle.getAttribute('aria-expanded') !== 'true';
			toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
			panel.classList.toggle('is-open', open);
		});
	}

	/* -- keyword placeholder --------------------------------------------------- */

	// S&F's field 8 says "Search Jobs" (set in the plugin and used elsewhere on
	// the site); on this page it reads "Search by keyword". S&F mounts and
	// re-renders the field, so set it whenever it appears.
	function setKeywordPlaceholder() {
		var input = main.querySelector('.ashs-jobs-field--keyword input[type="text"]');
		if (input && input.getAttribute('placeholder') !== 'Search by keyword') {
			input.setAttribute('placeholder', 'Search by keyword');
		}
	}

	/* -- search button ------------------------------------------------------- */

	function initSearchButton() {
		var button = main.querySelector('.ashs-jobs-search__go');
		var results = main.querySelector('.ashs-jobs-results');
		if (!button) { return; }

		button.addEventListener('click', function () {
			var input = main.querySelector('.ashs-jobs-field--keyword input[type="text"]');
			if (input && input.value.trim() !== '') {
				['keydown', 'keyup'].forEach(function (type) {
					input.dispatchEvent(new KeyboardEvent(type, { key: 'Enter', code: 'Enter', keyCode: 13, which: 13, bubbles: true }));
				});
			}
			if (results) {
				results.scrollIntoView({ behavior: 'smooth', block: 'start' });
			}
		});
	}

	/* -- job alerts ----------------------------------------------------------- */

	var ALERT_FIELDS = {
		profession: /profession/i,
		state: /state/i,
		website_specialty: /specialty/i
	};

	// Current filters: the archive's own term plus the chips.
	function currentFilters() {
		var filters = {};
		if (main.dataset.archiveTaxonomy) {
			filters[main.dataset.archiveTaxonomy] = main.dataset.archiveTerm;
		}
		each(main.querySelectorAll('.ashs-active-filters [data-filter-param]'), function (chip) {
			filters[chip.getAttribute('data-filter-param').replace(/^_/, '')] = chip.getAttribute('data-filter-label');
		});
		return filters;
	}

	function alertsIntro(f) {
		if (!f.profession && !f.website_specialty && !f.state) {
			return "We're adding new opportunities every day. Let us help you find the role that checks all your boxes.";
		}
		var what = [f.website_specialty, f.profession].filter(Boolean).join(' ');
		return "We'll email you when new " + (what ? what + ' ' : '') + 'jobs' + (f.state ? ' in ' + f.state : '') + ' are posted.';
	}

	// HubSpot's developer forms are React: a dropdown is a hidden input driven
	// by its option list, so pick the option; text inputs need the native setter.
	function setField(input, value) {
		var dropdown = input.closest('.hsfc-DropdownInput');
		if (dropdown) {
			if (input.value === value) { return; }
			each(dropdown.querySelectorAll('[role="option"]'), function (option) {
				if (option.textContent.trim().toLowerCase() === value.toLowerCase()) {
					option.click();
				}
			});
			return;
		}
		if (input.value) { return; }
		var setter = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set;
		setter.call(input, value);
		input.dispatchEvent(new Event('input', { bubbles: true }));
		input.dispatchEvent(new Event('change', { bubbles: true }));
	}

	function prefillAlerts(form, filters) {
		Object.keys(ALERT_FIELDS).forEach(function (key) {
			if (!filters[key]) { return; }
			each(form.querySelectorAll('input[name]'), function (input) {
				if (ALERT_FIELDS[key].test(input.name) && (input.type === 'hidden' || input.type === 'text')) {
					setField(input, filters[key]);
				}
			});
		});
	}

	function initAlerts() {
		var modal = document.getElementById('job-alerts-signup-modal');
		if (!modal) { return; }
		var form = modal.querySelector('.hs-form-html');
		var intro = modal.querySelector('[data-job-alerts-intro]');

		function open() {
			var filters = currentFilters();
			intro.textContent = alertsIntro(filters);
			modal.style.display = 'block';
			document.body.style.overflow = 'hidden';

			// The HubSpot form may still be rendering: fill it once it's there.
			prefillAlerts(form, filters);
			var observer = new MutationObserver(function () { prefillAlerts(form, filters); });
			observer.observe(form, { childList: true, subtree: true });
			setTimeout(function () { observer.disconnect(); }, 5000);

			window.dataLayer = window.dataLayer || [];
			window.dataLayer.push({ event: 'job_alerts_open', filters: filters });
		}

		function close() {
			modal.style.display = 'none';
			document.body.style.overflow = '';
		}

		document.addEventListener('click', function (e) {
			if (e.target.closest('[data-job-alerts-open]')) {
				e.preventDefault();
				open();
			}
		});
		modal.querySelector('.ashs-modal__close').addEventListener('click', close);
		modal.querySelector('.ashs-modal__overlay').addEventListener('click', function (e) {
			if (e.target === e.currentTarget) { close(); }
		});
		document.addEventListener('keydown', function (e) {
			if (e.key === 'Escape' && modal.style.display === 'block') { close(); }
		});
	}

	/* -- init ----------------------------------------------------------------- */

	toggleEmptyState();
	setKeywordPlaceholder();
	initFiltersToggle();
	initSearchButton();
	initAlerts();

	onResults(function () {
		toggleEmptyState();
		setKeywordPlaceholder();
	});
})();
